export default [
  {
    label: "CR80",
    width: 170,
    height: 54,
    bleed: 5,
  },
  {
    label: "Expobadge 260",
    width: 193,
    height: 268,
    bleed: 10,
  },
  {
    label: "Expobadge 260S",
    width: 193,
    height: 164,
    bleed: 10,
    background:
      "https://images.unsplash.com/photo-1702234728311-baaa6c8aa212?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wxMTY5OTZ8MHwxfGFsbHw0MHx8fHx8fDJ8fDE3MDI4MjUyODB8&ixlib=rb-4.0.3&q=80&w=1080",
  },
];
